import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { editorUrl, url } from 'utils/url';
import { errorMsg } from 'utils';
import fileDownload from 'js-file-download';
import moment from 'moment';

export const POIS_FETCH_DATA_INIT = createAction('POIS_FETCH_DATA_INIT');
export const POIS_FETCH_DATA_SUCCESS = createAction('POIS_FETCH_DATA_SUCCESS');
export const POIS_FETCH_DATA_FAIL = createAction('POIS_FETCH_DATA_FAIL');


export const POIS_FETCH_SHAPE_INIT = createAction('POIS_FETCH_SHAPE_INIT');
export const POIS_FETCH_SHAPE_SUCCESS = createAction(
  'POIS_FETCH_SHAPE_SUCCESS'
);
export const POIS_FETCH_SHAPE_FAIL = createAction('POIS_FETCH_SHAPE_FAIL');

export const POIS_DELETE_POI_INIT = createAction('POIS_DELETE_POI_INIT');
export const POIS_DELETE_POI_SUCCESS = createAction('POIS_DELETE_POI_SUCCESS');
export const POIS_DELETE_POI_FAIL = createAction('POIS_DELETE_POI_FAIL');

export const POIS_CLEAR_DATA = createAction('POIS_CLEAR_DATA');

export const POIS_CREATE_POI_INIT = createAction('POIS_CREATE_POI_INIT');
export const POIS_CREATE_POI_SUCCESS = createAction('POIS_CREATE_POI_SUCCESS');
export const POIS_CREATE_POI_FAIL = createAction('POIS_CREATE_POI_FAIL');

export const POIS_MODIFY_POI_INIT = createAction('POIS_MODIFY_POI_INIT');
export const POIS_MODIFY_POI_SUCCESS = createAction('POIS_MODIFY_POI_SUCCESS');
export const POIS_MODIFY_POI_FAIL = createAction('POIS_MODIFY_POI_FAIL');

export const POIS_CLEAN_UP = createAction('POIS_CLEAN_UP');

export const POIS_CLEAR_DATA_LOGOUT = createAction('POIS_CLEAR_DATA_LOGOUT');
export const POIS_EXPORT_POI_INIT = createAction('POIS_EXPORT_POI_INIT');
export const POIS_EXPORT_POI_SUCCESS = createAction('POIS_EXPORT_POI_SUCCESS');
export const POIS_EXPORT_POI_FAIL = createAction('POIS_EXPORT_POI_FAIL');

export const fetchPois = ({
  poiId,
  siteId,
  categoryId = 'all',
  type = 'published',
}) => {
  // eslint-disable-next-line
  return async (dispatch, getState) => {
    dispatch(POIS_FETCH_DATA_INIT());
    if (poiId) {
      let poiData;
      try {
        poiData = await Axios.get(`${url}/poi/list`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
          params: {
            siteId,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(POIS_FETCH_DATA_FAIL({ error }));
      }
      const poiFind = poiData.data.data.find((x) => x._id === poiId);
      const poi = { ...poiFind, id: poiId };
      return dispatch(
        POIS_FETCH_DATA_SUCCESS({
          list: getState().pois.list,
          poi,
        })
      );
    }

    if (siteId) {
      let pois;
      try {
        pois = await Axios.post(
          `${url}/poi/filter`,
          {
            siteId,
            categoryId,
            type,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
      } catch (error) {
        let errorMessage;
        if (error.response) {
          errorMessage = error && error.response && error.response.data.message;
        }
        toastr.error('', errorMessage);
        return dispatch(POIS_FETCH_DATA_FAIL({ error }));
      }
      pois = pois.data.data.filter((poi) => poi.siteId === siteId);
      const shapeNames = getState().pois.shape;
      if (shapeNames.size > 0) {
        pois = pois.map((poi) => ({
          ...poi,
          hasShape:
            poi.location &&
            poi.location.split(',').every((loc) => shapeNames.has(loc.trim())),
        }));
      }

      return dispatch(
        POIS_FETCH_DATA_SUCCESS({
          list: pois,
          poi: getState().pois.poi,
        })
      );
    }
  };
};


export const bulkRecovery = ({ status, ids, siteId }, cb) => {
  return async () => {
    try {
      await Axios.post(
        `${url}/poi/bulk-status-change `,
        {
          status,
          ids,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (e) {
      console.log(e, 'error');
      toastr.error('', 'Something went wrong');
    }
    cb();
  };
};

export const fetchShape = ({ siteId }) => {
  // eslint-disable-next-line
  return async (dispatch, getState) => {
    dispatch(POIS_FETCH_SHAPE_INIT());

    if (siteId) {
      let shape;
      try {
        shape = await Axios.get(`${editorUrl}/site/open/${siteId}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
      } catch (error) {
        let errorMessage;
        if (error.response) {
          errorMessage = error && error.response && error.response.data.message;
        }
        toastr.error('', errorMessage);
        return dispatch(POIS_FETCH_SHAPE_FAIL({ error }));
      }
      shape = shape.data.data.freeShapes;

      if (Array.isArray(shape)) {
        const shapeNames = new Set(shape.map((sh) => sh.name));


        return dispatch(
          POIS_FETCH_SHAPE_SUCCESS({
            shape: shapeNames,
          })
        );
      }
      toastr.error('', 'Shape is empty');
      return dispatch(POIS_FETCH_SHAPE_FAIL({ error: 'Shape is empty' }));
    } else {
      return dispatch(
        POIS_FETCH_SHAPE_SUCCESS({
          shape: [],
        })
      );
    }
  };
};

export const removePoi = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(POIS_DELETE_POI_INIT());
    try {
      await Axios.post(
        `${url}/poi/remove`,
        {
          poiId: id,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        POIS_DELETE_POI_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The poi was removed.');
    cb();
    return dispatch(POIS_DELETE_POI_SUCCESS({ id }));
  };
};

export const deletePoi = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(POIS_DELETE_POI_INIT());
    try {
      await Axios.post(
        `${url}/poi/delete`,
        {
          poiId: id,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        POIS_DELETE_POI_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The poi was deleted.');
    cb();
    return dispatch(POIS_DELETE_POI_SUCCESS({ id }));
  };
};

export const clearPoisData = () => {
  return (dispatch) => {
    dispatch(POIS_CLEAR_DATA());
  };
};

export const clearPoisDataLogout = () => {
  return (dispatch) => {
    dispatch(POIS_CLEAR_DATA_LOGOUT());
  };
};

export const createPoi = ({
  name,
  phone,
  priority,
  description,
  file,
  opentime,
  url: poiUrl,
  categoryId,
  categoryName,
  floorId,
  floorName,
  siteId,
  location,
  floor,
  tags,
  firstFileList,
  secondFileList,
  categoryIds,
  subCategoryIds,
  start,
  end,
}) => {
  return async (dispatch) => {
    dispatch(POIS_CREATE_POI_INIT());

    // let createPoi;

    const poi = new FormData();
    poi.set('path', 'poi');
    poi.set('name', name);
    poi.set('phone', phone);
    poi.set('priority', priority);
    poi.set('description', description);
    poi.set('opentime', opentime);
    poi.set('url', poiUrl);
    if (categoryId) {
      poi.set('categoryId', categoryId);
      poi.set('categoryName', categoryName);
    }
    if (tags) poi.set('tags', JSON.stringify(tags));
    if (categoryIds.length > 0) {
      poi.set('categoryIds', JSON.stringify(categoryIds));
      poi.set('categoryId', categoryIds[0]);
    }
    if (subCategoryIds)
      poi.set('subCategoryIds', JSON.stringify(subCategoryIds));

    if (floorId) {
      poi.set('floorId', floorId);
      poi.set('floorName', floorName);
    }
    poi.set('siteId', siteId);
    poi.set('location', location);
    poi.set('floor', floor);
    if (file) poi.append('file', file, `logo-${file.name}`);
    if (firstFileList) {
      for (let ind = 0, l = firstFileList.length; ind < l; ind += 1) {
        if (firstFileList[ind])
          poi.append(
            'file',
            firstFileList[ind],
            `firstMedias-${firstFileList[ind].name}`
          );
      }
    }
    if (secondFileList) {
      for (let ind = 0, l = secondFileList.length; ind < l; ind += 1) {
        if (secondFileList[ind])
          poi.append(
            'file',
            secondFileList[ind],
            `secondMedias-${secondFileList[ind].name}`
          );
      }
    }
    if (start && end) {
      poi.set('start', moment(start).format('YYYY-MM-DD'));
      poi.set('end', moment(end).format('YYYY-MM-DD'));
    }

    try {
      await Axios.post(`${url}/poi/create`, poi, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      // let errorMessage;
      // if (error.response) {
      //   errorMessage = error && error.response && error.response.data.message;
      // }

      toastr.error('', 'Please fill in all required fields');
      // toastr.error('', errorMessage);
      return dispatch(
        POIS_CREATE_POI_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    const poiJson = JSON.stringify(Object.fromEntries(poi));
    toastr.success('', 'Poi created successfully');
    return dispatch(POIS_CREATE_POI_SUCCESS({ poi: poiJson }));
  };
};

export const modifyPoi = ({
  id,
  name,
  phone,
  priority,
  description,
  file,
  logo,
  opentime,
  url: poiUrl,
  categoryId,
  categoryName,
  floorId,
  floorName,
  tags,
  siteId,
  location,
  floor,
  firstMedias,
  secondMedias,
  firstFileList,
  secondFileList,
  categoryIds,
  subCategoryIds,
  start,
  end,
}) => {
  return async (dispatch) => {
    dispatch(POIS_MODIFY_POI_INIT());

    const poi = new FormData();
    poi.set('path', 'poi');
    poi.set('id', id);
    poi.set('name', name);
    poi.set('phone', phone);
    poi.set('priority', priority);
    poi.set('description', description);
    poi.set('opentime', opentime);
    poi.set('url', poiUrl);
    if (categoryId && categoryName) {
      poi.set('categoryId', categoryId);
      poi.set('categoryName', categoryName);
    }
    if (categoryIds.length > 0) {
      poi.set('categoryIds', JSON.stringify(categoryIds));
      poi.set('categoryId', categoryIds[0]);
    }
    if (subCategoryIds)
      poi.set('subCategoryIds', JSON.stringify(subCategoryIds));
    if (floorId && floorName) {
      poi.set('floorId', floorId);
      poi.set('floorName', floorName);
    }
    poi.set('siteId', siteId);
    if (tags) poi.set('tags', JSON.stringify(tags));
    poi.set('location', location);
    poi.set('floor', floor);
    poi.set('firstMedias', JSON.stringify(firstMedias));
    poi.set('secondMedias', JSON.stringify(secondMedias));
    if (logo) {
      poi.set('logo', logo);
    }
    if (file) poi.append('file', file, `logo-${file.name}`);
    if (firstFileList) {
      for (let ind = 0, l = firstFileList.length; ind < l; ind += 1) {
        if (firstFileList[ind])
          poi.append(
            'file',
            firstFileList[ind],
            `firstMedias-${firstFileList[ind].name}`
          );
      }
    }
    if (secondFileList) {
      for (let ind = 0, l = secondFileList.length; ind < l; ind += 1) {
        if (secondFileList[ind])
          poi.append(
            'file',
            secondFileList[ind],
            `secondMedias-${secondFileList[ind].name}`
          );
      }
    }

    if (start && end) {
      console.log(start, end, 'start and end scheduling');
      poi.set('start', moment(start).format('YYYY-MM-DD'));
      poi.set('end', moment(end).format('YYYY-MM-DD'));
    }

    try {
      await Axios.put(`${url}/poi/edit`, poi, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        POIS_MODIFY_POI_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    const poiJson = JSON.stringify(Object.fromEntries(poi));
    toastr.success('', 'Poi updated successfully');
    return dispatch(POIS_MODIFY_POI_SUCCESS({ poiJson, id }));
  };
};

export const downloadPois = ({ siteId, siteName }) => {
  return async (dispatch) => {
    dispatch(POIS_EXPORT_POI_INIT());
    Axios.get(`${url}/poi/export`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      responseType: 'blob',
      params: {
        siteId,
      },
    })
      .then((res) => {
        fileDownload(
          res.data,
          `poi_export_${siteName}_${moment(new Date()).format(
            'YYYY-MM-DD'
          )}.xlsx`
        );
        return dispatch(POIS_EXPORT_POI_SUCCESS());
      })
      .catch((error) => {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(POIS_EXPORT_POI_FAIL({ error }));
      });
  };
};

export const poisCleanUp = () => (dispatch) => dispatch(POIS_CLEAN_UP());
